import { useLocalization } from '@fluent/react';

import ContactPointCard from '#/components/cards/ContactPointCard';
import { FragmentType, getFragmentData } from '#/__generated__/graphql';
import {
  DigitalDocument,
  FreightDeliveryDetailsPanelFragmentDoc,
} from '#/__generated__/graphql/graphql';

const FreightDeliveryInfoPanel: React.FC<FreightDeliveryInfoPanelProps> = ({
  attachments,
  companyName,
  freightDelivery: _freightDelivery,
}) => {
  const { l10n } = useLocalization();
  const freightDelivery = getFragmentData(FreightDeliveryDetailsPanelFragmentDoc, _freightDelivery);

  return (
    <div className="divide-y">
      <div className="grid grid-cols-2">
        <InfoItem className="pb-6" label={l10n.getString('driver')}>
          <ContactPointCard name={freightDelivery?.driver ?? ''} />
        </InfoItem>
        <InfoItem label={l10n.getString('vehicle-type')}>{freightDelivery?.vehicle.name}</InfoItem>
      </div>

      <div className="py-6">
        <InfoItem label={l10n.getString('logistics')}>{companyName}</InfoItem>
      </div>
      {!!attachments && attachments.length > 0 && (
        <div className="pt-6">
          <InfoItem label={l10n.getString('attachments')}>
            {attachments.map((file) => (
              <div className="max-w-fit" key={file.url}>
                <a href={file.url} download={file.name} target="_blank">
                  <div className="px-3 py-2 border border-black rounded-full hover:bg-slate-200">
                    {file.name}
                  </div>
                </a>
              </div>
            ))}
          </InfoItem>
        </div>
      )}
    </div>
  );
};
export type FreightDeliveryInfoPanelProps = {
  attachments?: DigitalDocument[];
  companyName: string;
  freightDelivery?: FragmentType<typeof FreightDeliveryDetailsPanelFragmentDoc>;
};

const InfoItem: React.FC<InfoItemProps> = ({ className, label, children }) => (
  <div className={className}>
    <span className="label mb-2">{label}</span>
    <span className="block">{children}</span>
  </div>
);
type InfoItemProps = { className?: string; label: string };

export default FreightDeliveryInfoPanel;
